// TODO: Confirm text alignment with design team

import ContactCenterText from '@assets/contact-center.svg';
import ProBadge from '@assets/pro.svg';
import ServiceTitanIcon from '@assets/st-logo-icon-gray.svg';
import { ContactCenterContainer } from './styled';
import { logoLocators } from '@locators/logo';
import { getTestIdProps } from '@lib/testUtils';

type ContactCenterLogoProps = {
  showIcon?: boolean;
};

export function ContactCenterLogo({
  showIcon = false,
}: ContactCenterLogoProps) {
  if (showIcon) {
    return (
      <ContactCenterContainer $showIcon={showIcon}>
        <ServiceTitanIcon {...getTestIdProps(logoLocators.logoIconElement)} />
        <ContactCenterText width={171} height={19} />
        <ProBadge width={43} height={26} />
      </ContactCenterContainer>
    );
  }

  return (
    <ContactCenterContainer $showIcon={showIcon}>
      <ContactCenterText />
      <ProBadge />
    </ContactCenterContainer>
  );
}
